const footerElement = document.querySelector('.footer--wrap');
const footerElementClassMobile = 'footer--mobile';
const footerContent = footerElement.innerHTML;

function init() {
  const smallScreen = (window.innerWidth <= 767) ? true : false;

  if (footerElement) {
    if (smallScreen) {
      smallFooterHTML();
    } else {
      bigFooterHTML();
    }
  }

}

// Small/Mobile HTML - set new structure
function smallFooterHTML() {
  if (!footerElement.classList.contains(footerElementClassMobile)) {
    const footerContainer         = document.querySelector('.footer .footer__container');
    const footerMetaInfos         = document.querySelector('.footer .footer__metainfos');
    const footerLogos             = document.querySelector('.footer .footer__logos');
    const footerNavigation        = document.querySelector('.footer .footer__navigation');
    const footerMadeByDW          = document.querySelector('.footer .footer__madebydigitalwerk');
    const footerMobileWrapper_1   = document.createElement('div');
    footerMobileWrapper_1.className = 'footer__mobilewrapper--1';

    if (footerMetaInfos) {
      footerMetaInfos.appendChild(footerMobileWrapper_1);
      footerMobileWrapper_1.appendChild(footerLogos);
      footerMobileWrapper_1.appendChild(footerNavigation);
    }

    if (footerContainer) {
      if (footerMadeByDW) {
        footerContainer.appendChild(footerMadeByDW);
      }
    }

    footerElement.classList.add(footerElementClassMobile);
  }
}

// Big/Desktop HTML - reset structure
function bigFooterHTML() {
  footerElement.innerHTML = footerContent;
  footerElement.classList.remove(footerElementClassMobile);
}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Mobilefooter.js